<template>
  <footer class="footer">
    <div class="container">
      <div class="columns">
        <div class="column is-4">
          <img class="logoClass" src="/static/logo.png">
          <p class="footerInfo">
            Nuestra misión es aportar soluciones para el control integrado de plagas que afectan la salud, la
            tranquilidad y la economía del hombre en las diferentes áreas donde se desenvuelve, por medio de
            asesoría técnica profesional, capacitación y productos efectivos a precios justos.
          </p>
        </div>
        <div class="column is-4">
          <p class="footerMap">
            <a href="https://www.google.com/maps/@14.5945742,-90.5766572,17.25z"><img src="/static/images/newmap.png"/></a>
          </p>
        </div>
        <div class="column is-4">
          <p class="footerContact">
            2da calle 18-87 sector B-1<br/>
            Ciudad San Cristobal zona 8 de Mixco<br/>
            Guatemala<br/><br/>
            (502) 2478 - 1179 / 80 / 82 / 99<br/><br/>
            <a href="https://wa.me/50240251346"><img width="20px" height="20px" class="iconImage" src="/static/images/whatsapp-icon.png"/>WhatsApp: (502) 4025 - 1346</a><br/><br/>
            <a href="mailto:ventas@hipromeasa.com"><img width="20px" height="20px" class="iconImage" src="/static/images/mail-icon.png"/>E-Mail: ventas@hipromeasa.com</a><br/><br/>
            <a href="https://www.facebook.com/hipromeasa"><img width="20px" height="20px" class="iconImage" src="/static/images/facebook-icon.png"/>Estamos en Facebook</a><br/>
          </p>
        </div>
      </div>
      <div class="content has-text-centered">
        <p class="footerLast">2020 - Todos los derechos reservados</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footerInfo {
    margin-left: 100px;
    margin-right:60px;
    text-align: center;
    font-size: small;
  }
  .footerContact {
    text-align: left;
    font-size: small;
    margin-left: 60px;
    margin-right: 80px;
    margin-top: 50px;
  }
  .footerMap {
    margin-top: 50px;
    margin-left: 20px;
  }
  .footerLast {
    font-size: small;
    margin-bottom: 0px;
  }
  .iconImage {
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// FooterComponent.vue?86db5c76